module.exports = __webpack_public_path__ + "img/dz.6d4c68f8.svg";